export default {
    changePayType(state, type) {
        state.pay_type = type
    },
    changePayMode(state, type) {
        state.pay_mode = type
    },
    getProducts(state, res) {
        state.cartData = res;
        state.payment_modes = res.data.payment_modes;

        state.CartTotal = {
            subtotal: res.data.subtotal_label,
            shipping: res.data.shipping,
            discount_label: res.data.discount_label,
            discount: res.data.discount,
            offer_saving: res.data.offer_saving,

            coupon_label: res.data.coupon?.coupon_discount_label
                ? res.data.coupon?.coupon_discount_label
                : 0,
            coupon_discount: res.data.coupon?.coupon_discount
                ? res.data.coupon?.coupon_discount
                : 0,

            tax_percent_label: res.data.tax_percent_label,
            tax_label: res.data.tax_label,

            partially_paid: res.data.partially_paid,

            couponData: res.data.coupon,

            total: res.data.total_label,

            total_saving: res.data.total_saving_label,

            subtotal_saving: res.data.subtotal_saving,

            coupon_code: res.data.coupon.coupon,

            eta: res.data.eta,

            split: res.data.split,
            is_duplicate: res.data.is_duplicate,
            availability: res.data.availability,
            availability: res.data.availability,
            // partially_paid: res.data.partially_paid,
            has_free_product: res.data.has_free_product,
            free_product: res.data.free_product,
            // d_locked: posts.d_locked,
        };
    },
    setLoaderStatus(state, status) {
        state.showButtonLoader = status
    },
    setPaymentModes(state, data) {
        // console.log('state \u{1F680}', state,data)
        state.payment_modes = data
    },
    setModalContent(state, msg) {
        state.modalContent = msg
    },
    setModalStatus(state, status) {
        state.flagShowModal = status
    },
    setProcessStatus(state, status) {
        state.processStatus = status
    },
    setPaymentSkeleton(state, status) {
        state.paymentSkeleton = status
    },
    setGatewayComponentKey(state) {
        state.gatewayComponentKey++
    },
    setGatwayStatus(state, data) {
        state.gatwayStatus = data
    },
    setCreatePlanData(state, data) {
        state.createPlanData = data
    },
    setSplitAmt(state, amount) {
        state.first_split_amount = amount
    },
    setIsAddressSet(state, status) {
        state.is_address_set = status
    }
}